import { render, staticRenderFns } from "./cModalStoreDispatch.vue?vue&type=template&id=bc78f5da&scoped=true&lang=es"
import script from "./cModalStoreDispatch.vue?vue&type=script&lang=js"
export * from "./cModalStoreDispatch.vue?vue&type=script&lang=js"
import style0 from "./cModalStoreDispatch.vue?vue&type=style&index=0&id=bc78f5da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc78f5da",
  null
  
)

export default component.exports